/**
 * AssetScanTypeService
 * Service for AssetScanType lookup CRUD operations
 */
import { CrudService } from '../base/CrudService';
/** Service for AssetScanType CRUD operations */
export class AssetScanTypeService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? AssetScanTypeService.DEFAULT_SERVICE_PATH,
            basePath: AssetScanTypeService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
}
AssetScanTypeService.DEFAULT_SERVICE_PATH = 'assetmanagement';
AssetScanTypeService.BASE_PATH = 'api/asset-scan-types';
//# sourceMappingURL=AssetScanTypeService.js.map